'use client';

import React, { useMemo, type PropsWithChildren } from 'react';
import { DataProvider, GlobalActionsProvider } from '@plasmicapp/loader-nextjs'; // or "@plasmicapp/host"

// Users will be able to set these props in Plasmic Studio
interface PlasmicStateContextProps { }

export const PlasmicStateContext = ({
  children,
}: PropsWithChildren<PlasmicStateContextProps>) => {
  // Connect data and functions from zustand store here to pass to Plasmic Studio below

  const data = useMemo(() => {
    // Add data
  }, []);

  const actions = useMemo(
    () => ({
      // Add functions
    }),
    []
  );

  return (
    <GlobalActionsProvider contextName="PlasmicStateContext" actions={actions}>
      <DataProvider name="state" data={data}>
        {children}
      </DataProvider>
    </GlobalActionsProvider>
  );
};
